import React, { FC } from 'react';

import { Navigator } from 'src/v2/features/quantumNavigator';

export const ProjectQuantumNavigator: FC = () => <Navigator checkDefaultOpenState={undefined} />;
